import { Image3D } from '~/domain/patient/image3d';
import { Patient } from '~/domain/patient/patient';

export function findImageBySeriesUid(
    patient: Patient | undefined,
    seriesUid: string | undefined
): Image3D | undefined {
    return seriesUid
        ? patient?.images.find((image) => image.seriesUid === seriesUid)
        : undefined;
}
